import { CollectionViewer, DataSource, } from '@angular/cdk/collections';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { OrderService } from 'src/app/data/order.service';
import { OrderRealizationItemsDto } from 'src/app/models/dtos/orders/order-realization-items-dto';
import { IPagedResult } from 'src/app/shared/models/PagedResult';

@Injectable()
export class OrdersRealizationListDataSource extends DataSource<OrderRealizationItemsDto> {
  private orderService = inject(OrderService);

  public orderRealizationItemsSubject = new BehaviorSubject<OrderRealizationItemsDto[]>([]);
  private countSubject = new BehaviorSubject<number>(0);
  public count$ = this.countSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(true);
  public loading$ = this.loadingSubject.asObservable();


  constructor() {
    super();
  }

  connect(collectionViewer: CollectionViewer): Observable<OrderRealizationItemsDto[]> {
    return this.orderRealizationItemsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.orderRealizationItemsSubject.complete();
    this.loadingSubject.complete();
    this.countSubject.complete();
  }

  fetchOrderRealizationItems(periodFrom: Date, periodTo: Date, page: number, count: number, sortingField: string, sortingDirection: string) {
    this.loadingSubject.next(true);
    const response$ = this.orderService
      .getRealizationItems(periodFrom, periodTo, page, count, sortingField, sortingDirection)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
    const orderRealizationItems$ = response$.pipe(map((response: IPagedResult<OrderRealizationItemsDto>) => response.Results));
    const count$ = response$.pipe(map((response: IPagedResult<OrderRealizationItemsDto>) => response.Count));
    orderRealizationItems$.subscribe(result => this.orderRealizationItemsSubject.next(result));
    count$.subscribe(count => this.countSubject.next(count));
  }
}
